import { render, staticRenderFns } from "./PhoneSolution.vue?vue&type=template&id=04ebdb50&scoped=true&"
import script from "./PhoneSolution.vue?vue&type=script&lang=js&"
export * from "./PhoneSolution.vue?vue&type=script&lang=js&"
import style0 from "./PhoneSolution.vue?vue&type=style&index=0&id=04ebdb50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ebdb50",
  null
  
)

export default component.exports